import React from "react";

const ReduireIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none">
      <path
        d="M9.54801 17.4198L8.48701 18.4798L2.70801 12.7028C2.61486 12.6102 2.54093 12.5001 2.49048 12.3789C2.44003 12.2576 2.41406 12.1276 2.41406 11.9963C2.41406 11.8649 2.44003 11.7349 2.49048 11.6137C2.54093 11.4924 2.61486 11.3823 2.70801 11.2898L8.48701 5.50977L9.54701 6.56977L4.12301 11.9948L9.54801 17.4198Z"
        fill="black"
      />
    </svg>
  );
};

export default ReduireIcon;
